import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

// Components
import { FiltersComponent } from './list-page/filters/filters.component';
import { BottomBarComponent } from './bottom-bar/bottom-bar.component';

import { SharedModule } from '../shared/shared.module';
import { MenuHomeComponent } from './home-page/menu-home/menu-home.component';
import { SuperSectionGridComponent } from './home-page/super-section/super-section-grid/super-section-grid.component';
import { SuperSectionListComponent } from './home-page/super-section/super-section-list/super-section-list.component';
import { SuperSectionScrollComponent } from './home-page/super-section/super-section-scroll/super-section-scroll.component';
import { SearchEmptyStateComponent } from './search-empty-state/search-empty-state.component';
import { CartBlockComponent } from './cart-block/cart-block.component';
import { PromotionComponent } from '../shared/promotion/promotion.component';
import { MenuListComponent } from './list-page/menu-list/menu-list.component';
import { BannerComponent } from './list-page/banner/banner.component';
import { SettingComponent } from './list-page/setting/setting.component';

@NgModule({
  declarations: [
    FiltersComponent,
    BottomBarComponent,
    MenuHomeComponent,
    SuperSectionGridComponent,
    SuperSectionListComponent,
    SuperSectionScrollComponent,
    SearchEmptyStateComponent,
    CartBlockComponent,
    MenuListComponent,
    BannerComponent,
    SettingComponent,
  ],
  imports: [
    CommonModule,
    SharedModule,
    PromotionComponent
  ]
})

export class MenuModule { }
